module.exports = __webpack_public_path__ + "media/images/client-10-ec04910b50daacce9eaec3eac4a0bfd8.png";